// Condición de un EPP entregado (epp_assignments.condition). La base solo acepta estos cuatro valores
// (epp_assignments_condition_check: nuevo, bueno, regular, malo); "Malo" cubre el EPP deteriorado. Antes la pantalla
// ofrecía "Deteriorado", que la base rechazaba al guardar. epp-condiciones.test.ts compara esta lista con la base.

export const CONDICIONES_EPP = ['nuevo', 'bueno', 'regular', 'malo'] as const;
export type CondicionEpp = typeof CONDICIONES_EPP[number];

export const ETIQUETA_CONDICION_EPP: Record<CondicionEpp, string> = {
  nuevo:   'Nuevo',
  bueno:   'Bueno',
  regular: 'Regular',
  malo:    'Malo',
};

export const COLOR_CONDICION_EPP: Record<CondicionEpp, string> = {
  nuevo:   '#22c55e',
  bueno:   '#3b82f6',
  regular: '#f59e0b',
  malo:    '#ef4444',
};
